import axios from 'axios';
import { LoadingStates } from 'shared/constants/loadingStates';
import _ from 'lodash';
import { PLANT_API_BASE_URL } from 'shared/constants/constants';

const { createSlice, createAsyncThunk } = require('@reduxjs/toolkit');

const initialState = {
  data: undefined,
  status: 'idle',
  error: null,
};

const plantDesignReferenceDataSlice = createSlice({
  name: 'plantDesignReferenceData',
  initialState,
  reducers: {
    clearPlantDesignReferenceData() {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPlantDesignReferenceData.pending, (state, action) => {
        state.status = LoadingStates.Loading;
        state.error = null;
      })
      .addCase(getPlantDesignReferenceData.fulfilled, (state, action) => {
        state.data = action.payload;
        state.status = LoadingStates.Succeeded;
      })
      .addCase(getPlantDesignReferenceData.rejected, (state, action) => {
        state.status = LoadingStates.Rejected;
        state.error = action.error.message;
      });
  },
});

const apiUrl = `${PLANT_API_BASE_URL}/licence/PDRA/lovs/2`;

export const getPlantDesignReferenceData = createAsyncThunk(
  'plantDesignReferenceData/getPlantDesignReferenceData',
  async () => {
    const res = await axios.get(apiUrl, {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    const response = await res.data.response;

    // HACK: Replace all picklist values with description
    for (let res in response) {
      if (res.endsWith('_picklistvalues')) {
        response[res]?.forEach((element) => (element.value = element.description));
      }
    }
    return response;
  },
  {
    condition: (arg, { getState, extra }) => {
      const { passwordlessOidc, plantDesignReferenceData } = getState();
      return (
        !!passwordlessOidc?.user?.access_token && _.isEmpty(plantDesignReferenceData.data)
        // plantDesignReferenceData.status !== LoadingStates.Loading
      );
    },
  },
);

export const { clearPlantDesignReferenceData } = plantDesignReferenceDataSlice.actions;
export const plantDesignReferenceDataReducer = plantDesignReferenceDataSlice.reducer;
